import React from 'react';
import {
  useMap,
  useMapsLibrary,
  ControlPosition,
} from '@vis.gl/react-google-maps';
import {userDrewShape} from './mapping-actions';
import {
  useDispatch,
  useSelector,
} from 'react-redux';

const MapMyFieldDrawingTools = (props) => {

  const dispatch = useDispatch();

  const {
    showDrawFieldBoundaryControls,
    userTappedResetDrawingCount,
   } = useSelector(state => state.mapping);

  const map = useMap();

  const drawingLib = useMapsLibrary('drawing');

  const [drawingManager, setDrawingManager] = React.useState(null);

  const [userDrawnShapes] = React.useState([]);

  React.useEffect(() => {
    if (showDrawFieldBoundaryControls === false && userDrawnShapes.length > 0) {
      userDrawnShapes.forEach((shape) => {
        shape.overlay.setMap(null);
      });
      userDrawnShapes.length = 0;
    }
  }, [userDrawnShapes, showDrawFieldBoundaryControls]);

  React.useEffect(() => {
    if (userTappedResetDrawingCount > 0 && userDrawnShapes.length > 0) {
      userDrawnShapes.forEach((shape) => {
        shape.overlay.setMap(null);
      });
      userDrawnShapes.length = 0;
    }
  }, [userDrawnShapes, userTappedResetDrawingCount]);

  const handleOverlayComplete = (e) => {
    userDrawnShapes.push(e);
    if (e.type === 'circle') {
      dispatch(userDrewShape({
        type: e.type,
        centerLatitude: e.overlay.center.lat(),
        centerLongitude: e.overlay.center.lng(),
      }));
    }
    else if (e.type === 'rectangle') {
      dispatch(userDrewShape({
        type: e.type,
        centerLatitude: e.overlay.bounds.getCenter().lat(),
        centerLongitude: e.overlay.bounds.getCenter().lng(),
      }));
    }
    else if (e.type === 'polygon') {
      var bounds = new window.google.maps.LatLngBounds();
      e.overlay.getPath().forEach((vertex) => {
        bounds.extend(vertex);
      });
      var center = bounds.getCenter();
      dispatch(userDrewShape({
        type: e.type,
        centerLatitude: center.lat(),
        centerLongitude: center.lng(),
      }));
    }
  }

  React.useEffect(() => {
    if (drawingLib === null || drawingManager !== null) {
      return;
    }
    const manager = new drawingLib.DrawingManager({
      drawingMode: null,
      drawingControl: true,
      drawingControlOptions: {
        position: ControlPosition.TOP_CENTER,
        drawingModes: [
          drawingLib.OverlayType.CIRCLE,
          drawingLib.OverlayType.POLYGON,
          drawingLib.OverlayType.RECTANGLE,
        ],
      },
      circleOptions: {
        clickable: true,
        editable: true,
        zIndex: 1,
        strokeColor: 'black',
        strokeOpacity: 1,
        strokeWeight: 1,
        fillColor: '#FF5F00',
        fillOpacity: 0.50,
      },
      polygonOptions: {
        clickable: true,
        editable: true,
        zIndex: 1,
        strokeColor: 'black',
        strokeOpacity: 1,
        strokeWeight: 1,
        fillColor: '#FF5F00',
        fillOpacity: 0.50,
      },
      rectangleOptions: {
        clickable: true,
        editable: true,
        zIndex: 1,
        strokeColor: 'black',
        strokeOpacity: 1,
        strokeWeight: 1,
        fillColor: '#FF5F00',
        fillOpacity: 0.50,
      },
    });
    manager.addListener('overlaycomplete', (e) => handleOverlayComplete(e));
    setDrawingManager(manager);
  }, [drawingLib, drawingManager]); // eslint-disable-line react-hooks/exhaustive-deps

  React.useEffect(() => {
    if (drawingManager === null || map === null) {
      return;
    }
    if (props.visible === true) {
      drawingManager.setMap(map);
    }
    else {
      drawingManager.setMap(null);
    }
  }, [drawingManager, map, props.visible]);

  return null;
};

export default MapMyFieldDrawingTools;
